import einrichtungKlient_de from './einrichtung-klient-de';
import einrichtungKlient_en from './einrichtung-klient-en';

export const customerOverrides: Record<string, { de: any; en: any }> = {
  einrichtungKlient: {
    de: einrichtungKlient_de,
    en: einrichtungKlient_en,
  },
};
